import find from 'lodash/find';
import isEqual from 'lodash/isEqual';


class SingleSelect {
  constructor($scope, $element, $timeout) {
    'ngInject';

    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$element = $element;
    let controller = this;

    $scope.$watch('$ctrl.selectedValue', function (newValue) {
      if (controller.notEqual(controller.localSelectedValue, newValue)) {
        controller.localSelectedValue = controller.normalize(newValue);
        controller.$timeout(() => {
          if (controller.selectElement) controller.selectElement.trigger('change');
        });
      }
    });
  }

  normalize(value) {
    const normalValue = this.idKey
      ? find(this.options, x => x[this.idKey] === value)
      : (!!value ? find(this.options, x => x.id === value.id && x.title == value.title) : find(this.options, x => x === value));
    return normalValue || '';
  }

  notEqual(localValue, value) {
    const normalValue = this.normalize(value);
    return !isEqual(localValue, normalValue);
  }

  $onInit() {
    this.placeholder = this.placeholder || 'All';
    this.labelKey = this.labelKey || 'title';
    this.imgKey = this.imgKey || 'avatar';
  }

  $onChanges(changes) {
    if (changes.disabled && this.selectElement) {
      this.selectElement.prop('disabled', !!this.disabled);
    }
    if (changes.options) {
      this.localSelectedValue = this.normalize(this.selectedValue);
    }
  }

  $postLink() {
    const formatState = (state) => {
      if (!state.id) {
        return state.text;
      }
      let userIcon = true;
      switch (this.mode) {

        case 'itemType':
          {
              const option = find(this.options, x => x.$$hashKey === state.id);
              if(!option)
              {
                  return state.text;
              }
              return $(`<i class="issue-type-${option.itemType}"></i>  <span title="${state.text}">${state.text}</span>`);            
          }
        case 'color':
        {
            const option = find(this.options, x => x.$$hashKey === state.id);
            if(!option)
            {
                return state.text;
            }
            const color = `<div style="float:left;height:14px;width:14px;border-radius:50%;background-color:${option.cssValue}"></div>`;
            return $(`<div class="single-select__color">${color}<span title="${state.text}" style="margin-left:5px; vertical-align: middle; color:${option.cssValue}">${state.text}</span><div> `);
          }
        case 'img':
          userIcon = false;
        case 'user':
          {
            const option = find(this.options, x => x.$$hashKey === state.id);
            const img = option[this.imgKey]
              ? `<img src="${option[this.imgKey]}" style="height:17px;width:17px;border-radius:2px;vertical-align:text-bottom;"/>`
              : `<i class="fa ${userIcon ? 'fa-user-circle-o' : 'fa-folder-o'}" aria-hidden="true" style="font-size: 17px;vertical-align:text-bottom;"></i>`;
            return $(`${img}<span style="margin-left:5px;vertical-align:top;line-height:19px;">${state.text}</span>`);
          }
        default:
          return state.text;
      }
    };
    this.selectElement = $(this.$element[0]).find('.single-select');
    this.selectElement.select2({
      placeholder: this.placeholder,
      theme: 'bootstrap',
      templateSelection: formatState,
      templateResult: formatState,
      disabled: !!this.disabled,
      minimumResultsForSearch: -1
    });
  }

  onLocalSelect() {
    if (this.notEqual(this.localSelectedValue, this.selectedValue)) {
      this.selectedValue = this.idKey
        ? this.localSelectedValue[this.idKey]
        : this.localSelectedValue;
      this.$timeout(() => {
        this.onSelect();
      });
    }
  }
}

export default SingleSelect;



// WEBPACK FOOTER //
// ../widgets/single-select/single-select.controller.js